/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cn_Android_Paywall_Benefit_Lose_TitleInputs */

const en_cn_android_paywall_benefit_lose_title = /** @type {(inputs: Cn_Android_Paywall_Benefit_Lose_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You are about to lose :`)
};

const ar_cn_android_paywall_benefit_lose_title = /** @type {(inputs: Cn_Android_Paywall_Benefit_Lose_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ستفقد المزايا التالية:`)
};

const de_cn_android_paywall_benefit_lose_title = /** @type {(inputs: Cn_Android_Paywall_Benefit_Lose_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Vorteile wirst du verlieren:`)
};

const es_cn_android_paywall_benefit_lose_title = /** @type {(inputs: Cn_Android_Paywall_Benefit_Lose_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perderás estas ventajas:`)
};

const fr_cn_android_paywall_benefit_lose_title = /** @type {(inputs: Cn_Android_Paywall_Benefit_Lose_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu vas perdre ces avantages :`)
};

const it_cn_android_paywall_benefit_lose_title = /** @type {(inputs: Cn_Android_Paywall_Benefit_Lose_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perderai questi vantaggi:`)
};

const ja_cn_android_paywall_benefit_lose_title = /** @type {(inputs: Cn_Android_Paywall_Benefit_Lose_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`次の特典が利用できなくなります：`)
};

const ko_cn_android_paywall_benefit_lose_title = /** @type {(inputs: Cn_Android_Paywall_Benefit_Lose_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`다음 혜택을 더 이상 이용할 수 없어요:`)
};

const pt_br_cn_android_paywall_benefit_lose_title = /** @type {(inputs: Cn_Android_Paywall_Benefit_Lose_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você perderá estes benefícios:`)
};

const ru_cn_android_paywall_benefit_lose_title = /** @type {(inputs: Cn_Android_Paywall_Benefit_Lose_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вы потеряете следующие преимущества:`)
};

const th_cn_android_paywall_benefit_lose_title = /** @type {(inputs: Cn_Android_Paywall_Benefit_Lose_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คุณจะเสียสิทธิประโยชน์ต่อไปนี้:`)
};

const tr_cn_android_paywall_benefit_lose_title = /** @type {(inputs: Cn_Android_Paywall_Benefit_Lose_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Şu avantajları kaybedeceksin:`)
};

const zh_cn_cn_android_paywall_benefit_lose_title = /** @type {(inputs: Cn_Android_Paywall_Benefit_Lose_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你将失去以下权益：`)
};

const zh_tw_cn_android_paywall_benefit_lose_title = /** @type {(inputs: Cn_Android_Paywall_Benefit_Lose_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你將失去以下權益：`)
};

/**
* | output |
* | --- |
* | "You are about to lose :" |
*
* @param {Cn_Android_Paywall_Benefit_Lose_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const cn_android_paywall_benefit_lose_title = /** @type {((inputs?: Cn_Android_Paywall_Benefit_Lose_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cn_Android_Paywall_Benefit_Lose_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cn_android_paywall_benefit_lose_title(inputs)
	if (locale === "ar") return ar_cn_android_paywall_benefit_lose_title(inputs)
	if (locale === "de") return de_cn_android_paywall_benefit_lose_title(inputs)
	if (locale === "es") return es_cn_android_paywall_benefit_lose_title(inputs)
	if (locale === "fr") return fr_cn_android_paywall_benefit_lose_title(inputs)
	if (locale === "it") return it_cn_android_paywall_benefit_lose_title(inputs)
	if (locale === "ja") return ja_cn_android_paywall_benefit_lose_title(inputs)
	if (locale === "ko") return ko_cn_android_paywall_benefit_lose_title(inputs)
	if (locale === "pt_br") return pt_br_cn_android_paywall_benefit_lose_title(inputs)
	if (locale === "ru") return ru_cn_android_paywall_benefit_lose_title(inputs)
	if (locale === "th") return th_cn_android_paywall_benefit_lose_title(inputs)
	if (locale === "tr") return tr_cn_android_paywall_benefit_lose_title(inputs)
	if (locale === "zh_cn") return zh_cn_cn_android_paywall_benefit_lose_title(inputs)
	return zh_tw_cn_android_paywall_benefit_lose_title(inputs)
});